import { createFileRoute, redirect } from "@tanstack/react-router";
import { companiesQueryOptions } from "@/auth/queryOptions";

/**
 * Root post-login landing. Picks a target company and bounces:
 *   1. If localStorage `lastCompanySlug` is still in the user's
 *      accessible list, use it.
 *   2. Otherwise pick the first company by name.
 *   3. If the user has zero companies, send them to /settings to add
 *      one.
 *
 * Resolution happens in `beforeLoad` so the user never sees this route
 * render — it's purely a redirect hop.
 */
export const Route = createFileRoute("/_authed/")({
  beforeLoad: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(companiesQueryOptions);
    if (data.companies.length === 0) {
      throw redirect({ to: "/settings" });
    }
    const stored =
      typeof window !== "undefined" ? localStorage.getItem("lastCompanySlug") : null;
    const target =
      data.companies.find((c) => c.slug === stored) ?? data.companies[0]!;
    // Non-admins land on Reports — the only thing they can do. Admins
    // get the dashboard (root of $companySlug).
    if (!target.isAdmin) {
      throw redirect({
        to: "/$companySlug/reports",
        params: { companySlug: target.slug },
      });
    }
    throw redirect({
      to: "/$companySlug",
      params: { companySlug: target.slug },
    });
  },
});
